import React from "react";

function NoPeople() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      data-name="Layer 1"
      viewBox="0 0 910.91 603"
    >
      <path
        fill="#feb8b8"
        d="M527.905 372l-16-10 9.833-24.96a13.438 13.438 0 0111.796-8.494 13.438 13.438 0 0111.314 21.67z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <path
        fill="#feb8b8"
        d="M299.193 493.934L277.164 484.381 289.117 459.779 306.908 470.19 299.193 493.934z"
      ></path>
      <path
        fill="#2f2e41"
        d="M435.187 681.763l-25.34-25.842a13.036 13.036 0 01.061-18.375l12.757-12.757a4.159 4.159 0 016.632.99c3.14 6.104 7.419 9.396 12.959 9.563 3.321.1 3.844-.023 4.71 3.185l-1.067 24.174 4.383 4.988a10.324 10.324 0 01.07 13.548 10.324 10.324 0 01-15.165.526zM452.905 623l-23-11 19-120-92.882 7.74c-29.367 2.447-53.608-23.815-47.655-52.676A37.29 37.29 0 01321.905 425l92 11 59.61 8.196a29.528 29.528 0 0124.815 22.905 29.528 29.528 0 01-.377 14.216z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <circle cx="148.86" cy="458" r="145" fill="#e6e6e6"></circle>
      <path
        fill="#3f3d56"
        d="M512.905 356l23 11-36.591 60.114a15.657 15.657 0 01-15.697 7.343 15.657 15.657 0 01-12.628-10.835l-40.874-78.181a20.895 20.895 0 0111.634-29.41 20.895 20.895 0 0126.754 13.27L487.905 389z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <path
        fill="#2f2e41"
        d="M412.318 326.68c7.509 1.04 15.222-1.435 21.488-5.702s11.218-10.213 15.41-16.53a107.11 107.11 0 0015.081-35.043 20.542 20.542 0 0020.017 6.964c11.923-2.677 19.073-16.589 16.748-28.585s-12.168-21.508-23.4-26.323-23.748-5.61-35.968-5.583c-8.057.018-16.27.394-23.838 3.158s-14.503 8.271-17.192 15.867c-1.686 4.762-1.631 10.033-3.548 14.707-3.48 8.486-12.505 13.12-20.976 16.635s-17.679 7.086-22.674 14.778c-5.64 8.685-4.013 20.807 2.203 29.09s16.2 13.087 26.36 15.096 20.627 1.511 30.97 1.007"
        transform="translate(-144.545 -148.5)"
      ></path>
      <path
        fill="#feb8b8"
        d="M264.193 493.934L242.164 484.381 254.117 459.779 271.908 470.19 264.193 493.934z"
      ></path>
      <path
        fill="#2f2e41"
        d="M400.187 681.763l-25.34-25.842a13.036 13.036 0 01.061-18.375l12.757-12.757a4.159 4.159 0 016.632.99c3.14 6.104 7.419 9.396 12.959 9.563 3.321.1 3.844-.023 4.71 3.185l-1.067 24.174 4.383 4.988a10.324 10.324 0 01.07 13.548 10.324 10.324 0 01-15.165.526zM414.905 629l-23-11 19-120-92.882 7.74c-29.367 2.447-53.608-23.815-47.655-52.676A37.29 37.29 0 01283.905 431l92 11 59.61 8.196a29.528 29.528 0 0124.815 22.905 29.528 29.528 0 01-.377 14.216z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <circle cx="303.86" cy="116" r="36.5" fill="#feb8b8"></circle>
      <path
        fill="#feb8b8"
        d="M422.905 350l-15-41c10.651-11.302 12.996-25.17 9-41l43 24z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <path
        fill="#3f3d56"
        d="M392.905 447c-26.698 8.91-62.03 5.995-106.299-9.162a7.778 7.778 0 01-3.369-12.4c29.858-35.096 56.647-69.47 78.754-102.741a58.152 58.152 0 0133.531-21.223L415.905 297l31 16 8.124 4.592a16.217 16.217 0 015.702 22.824c-12.448 30.413-28.673 58.179-56.826 77.584z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <path
        fill="#2f2e41"
        d="M449.251 257.398a39.222 39.222 0 0019.01 15.69c5.566 2.143 12.629 2.675 16.806-1.581 3.026-3.084 3.63-7.83 3.2-12.128-1.34-13.419-11.425-25.103-23.938-30.131s-26.958-3.929-39.446 1.161c-11.782 4.803-22.971 14.642-23.605 27.35-.325 6.511 2.033 13.682-1.463 19.186-2.633 4.145-7.718 5.83-12.273 7.665s-9.443 4.733-10.378 9.554c-.635 3.277.832 6.697 3.137 9.112a24.743 24.743 0 008.424 5.282c7.428 3.163 15.605 5.135 23.585 3.912s15.697-6.082 18.82-13.527c2.405-5.733 1.912-12.202 1.635-18.413s-.194-12.826 3.122-18.085 11.016-8.203 15.972-4.449"
        transform="translate(-144.545 -148.5)"
      ></path>
      <path
        d="M360.405 362.5s29 72 36 76 7-5.992 7-5.992z"
        opacity="0.2"
        transform="translate(-144.545 -148.5)"
      ></path>
      <path
        fill="#0a80ff"
        d="M588.027 339.027L412.016 367.66a3.306 3.306 0 01-3.79-2.729l-7.102-43.66a3.306 3.306 0 012.729-3.79l176.011-28.633a3.306 3.306 0 013.79 2.729l7.103 43.66a3.306 3.306 0 01-2.73 3.79z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <circle cx="286.206" cy="190.359" r="13.87" fill="#fff"></circle>
      <path
        fill="#fff"
        d="M460.883 324.589a2.312 2.312 0 10.742 4.563l107.562-17.498a2.312 2.312 0 10-.742-4.563zM463.11 338.279a2.312 2.312 0 10.742 4.563l107.562-17.498a2.312 2.312 0 00-.742-4.563z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <path
        fill="#feb8b8"
        d="M459.905 389l-16-10 9.833-24.96a13.438 13.438 0 0111.796-8.494 13.438 13.438 0 0111.314 21.67z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <path
        fill="#3f3d56"
        d="M443.905 373l23 11-36.591 60.114a15.657 15.657 0 01-15.697 7.343 15.657 15.657 0 01-12.628-10.835l-40.874-78.181a20.895 20.895 0 0111.634-29.41 20.895 20.895 0 0126.754 13.27L418.905 406z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <path
        fill="#e6e6e6"
        d="M1018.915 589.55c-13.25 18.73-16.75 125.33-17.53 159.5-.02.77-.04 1.5-.05 2.19h-33.54c-.41-.73-.79-1.45-1.15-2.19-19.88-39.24-8.85-86.29-8.27-88.67-1.51 7.48 5.32 29.16 13.04 50.16 4.71-64.57 44.98-117.73 47.5-120.99z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <path
        fill="#e6e6e6"
        d="M974.476 344.674h-270a5.006 5.006 0 01-5-5v-66.976a5.006 5.006 0 015-5h270a5.006 5.006 0 015 5v66.976a5.006 5.006 0 01-5 5zm-270-74.976a3.003 3.003 0 00-3 3v66.976a3.003 3.003 0 003 3h270a3.003 3.003 0 003-3v-66.976a3.003 3.003 0 00-3-3z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <circle cx="594.93" cy="157.686" r="21" fill="#e6e6e6"></circle>
      <path
        fill="#e6e6e6"
        d="M787.975 292.186a3.5 3.5 0 000 7h165a3.5 3.5 0 000-7zM787.975 313.186a3.5 3.5 0 000 7h165a3.5 3.5 0 000-7zM974.476 456.674h-270a5.006 5.006 0 01-5-5v-66.976a5.006 5.006 0 015-5h270a5.006 5.006 0 015 5v66.976a5.006 5.006 0 01-5 5zm-270-74.976a3.003 3.003 0 00-3 3v66.976a3.003 3.003 0 003 3h270a3.003 3.003 0 003-3v-66.976a3.003 3.003 0 00-3-3z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <circle cx="594.93" cy="269.686" r="21" fill="#e6e6e6"></circle>
      <path
        fill="#e6e6e6"
        d="M787.975 404.186a3.5 3.5 0 000 7h165a3.5 3.5 0 000-7zM787.975 425.186a3.5 3.5 0 000 7h165a3.5 3.5 0 000-7z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <path
        fill="#0a80ff"
        d="M839.476 232.5a42 42 0 1142-42 42.047 42.047 0 01-42 42zm0-82a40 40 0 1040 40 40.046 40.046 0 00-40-40z"
        transform="translate(-144.545 -148.5)"
      ></path>
      <path
        fill="#0a80ff"
        d="M856.048 186.357h-12.43v-12.43a4.143 4.143 0 10-8.286 0v12.43h-12.429a4.143 4.143 0 000 8.286h12.43v12.43a4.143 4.143 0 008.286 0v-12.43h12.429a4.143 4.143 0 100-8.286z"
        transform="translate(-144.545 -148.5)"
      ></path>
    </svg>
  );
}

export default NoPeople;
